import { FC } from 'react';

import { Box, BoxProps } from '@mui/material';

import wrapperStyles from './ContentWrapper.style';

interface IProps extends BoxProps {
  isSection?: boolean;
}

export const ContentWrapper: FC<IProps> = ({ children, sx = {}, isSection = false, ...restProps }) => (
  <Box {...restProps} component={`${isSection ? 'section' : 'div'}`} sx={{ ...wrapperStyles, ...sx }}>
    {children}
  </Box>
);
